import { BankruptcyCapabilityResponse } from "../../../api/ClientFileApi";
import { ChecklistStatus } from "../../BankruptcyChecklist.types";

// Any seizable amount above 0 € counts. This deliberately
// deviates from the legacy system, which required more than 12 €.
const MIN_EXCLUSIVE_SEIZABLE_AMOUNT = 0;

export function isBankruptcyCapabilityGiven(capability: BankruptcyCapabilityResponse): boolean {
  return capability.seizableAmount > MIN_EXCLUSIVE_SEIZABLE_AMOUNT;
}

export function getBankruptcyCapabilityStatus(capability: BankruptcyCapabilityResponse | undefined): ChecklistStatus {
  if (capability && capability.isAssetInventoryComplete && isBankruptcyCapabilityGiven(capability)) {
    return ChecklistStatus.Complete;
  }

  return ChecklistStatus.Warning;
}
